/**
 * Switch Language based on .env GATSBY_SITE_LANG
 */
import * as React from "react"

export const sitesUrls = (langCode, translatedUrls, langReplace) => {
  // const { i18n } = useTranslation();
  const langCodeSite = process.env.GATSBY_SITE_LANG || "en_US"

  const sitesList = {
    en_US: {
      url: "https://www.gefran.com",
      cptproductSlug: "products",
      cptApplicationSlug: "industrial-sectors",
      siteId: 1,
      wpUrl: "https://gefran.kinsta.cloud",
      wpUrlBuggy: "https://www.gefran.com",
    },
    it_IT: {
      url: "https://www.gefran.it",
      cptproductSlug: "prodotti",
      cptApplicationSlug: "settori-industriali",
      siteId: 2,
      wpUrl: "https://gefran.kinsta.cloud/it",
      wpUrlBuggy: "https://www.gefran.com/it",
    },
    fr_FR: {
      url: "https://www.gefran.fr",
      cptproductSlug: "produits",
      cptApplicationSlug: "secteurs-industriels",
      siteId: 3,
      wpUrl: "https://gefran.kinsta.cloud/fr",
      wpUrlBuggy: "https://www.gefran.com/fr",
    },
    de_DE: {
      url: "https://www.gefran.de",
      cptproductSlug: "produkte",
      cptApplicationSlug: "industriezweige",
      siteId: 4,
      wpUrl: "https://gefran.kinsta.cloud/de",
      wpUrlBuggy: "https://www.gefran.com/de",
    },
    es_ES: {
      url: "https://www.gefran.es",
      cptproductSlug: "productos",
      cptApplicationSlug: "sectores-industriales",
      siteId: 5,
      wpUrl: "https://gefran.kinsta.cloud/es",
      wpUrlBuggy: "https://www.gefran.com/es",
    },
    pt_PT: {
      url: "https://www.gefran.com.br",
      cptproductSlug: "produtos",
      cptApplicationSlug: "setores-industriais",
      siteId: 6,
      wpUrl: "https://gefran.kinsta.cloud/pt",
      wpUrlBuggy: "https://www.gefran.com/pt",
    },
    zh_CN: {
      url: "https://www.gefran.cn",
      cptproductSlug: "产品",
      cptApplicationSlug: "工业领域",
      siteId: 7,
      wpUrl: "https://gefran.kinsta.cloud/ch",
      wpUrlBuggy: "https://www.gefran.com/ch",
    },
  }

  // Check if only langCode is provided
  if (!translatedUrls && !langReplace) {
    return sitesList[langCode] || false;
  }

  Object.keys(sitesList).forEach(function (key) {
    const tSiteUrl = sitesList[key].url
    const cptproductSlug = sitesList[key].cptproductSlug
    const cptApplicationSlug = sitesList[key].cptApplicationSlug
    const tSiteId = sitesList[key].siteId

    // Compose the url
    let tUrl
    translatedUrls?.map((lang, index) => {
      if (lang.siteId === tSiteId) {
        // trim wordpress url (not present in main site)
        const trimmedUrl = lang.postUrl.replace(/^.*\/\/[^\/]+/, "")
        const tSlug = trimmedUrl.match("^/\\w{2}/")
          ? trimmedUrl.slice(3)
          : trimmedUrl
        tUrl = tSiteUrl + tSlug

        // The "products" and "application" slug is not been translated by wp language plugin
        // so we replace the string only for products and categories, that valorize langReplace
        if (langReplace === "applications") {
          tUrl = tUrl.replace(
            sitesList[langCodeSite].cptApplicationSlug,
            cptApplicationSlug
          )
        }

        if (langReplace === "products") {
          tUrl = tUrl.replace(
            sitesList[langCodeSite].cptproductSlug,
            cptproductSlug
          )
        }

        sitesList[key].tUrl = tUrl
      }
    })
  })

  if (langCode === "all") {
    return sitesList
  } else {
    return sitesList[langCode] || false
  }
}
